module.exports = __webpack_public_path__ + "static/img/10021.98e63fd7.png";